// Field help content for Offer, ICP/Strategy, Lead Finder, Campaign, Sequence.
// Each entry: one sentence of purpose, up to three bullets, one short example (~80 words max).
export const HELP = {
  offer_product: {
    purpose: "One line on what you sell - no slogans.",
    bullets: ["What it is and who it's for", "Say the category in plain words", "Skip taglines and adjectives"],
    example: "DealsOps is a paid B2B outbound control plane for 3-20 person revenue teams.",
  },
  offer_features: {
    purpose: "Three facts a buyer can verify.",
    bullets: ["Concrete capabilities, not benefits", "Things a demo would actually show", "Keep each to a few words"],
    example: "Lead sourcing, AI sequence copilot, native CRM pipeline.",
  },
  offer_proof: {
    purpose: "One logo, metric, or named result.",
    bullets: ["A number, customer, or outcome", "Be specific and true", "If none, write 'early / no public proof'"],
    example: "Cuts cost per meeting ~40% for design agencies.",
  },
  offer_pricing: {
    purpose: "How you charge, plus a price band.",
    bullets: ["Seat, usage, or project", "Add a rough range", "Note contract length if any"],
    example: "Seat-based; Professional is 499 a month.",
  },
  offer_outcome: {
    purpose: "What changes for the buyer in 90 days.",
    bullets: ["A measurable shift, not a feature", "Their win, tied to revenue or time", "Concrete and near-term"],
    example: "First approved campaign in 30 minutes; more booked meetings by day 90.",
  },
  offer_strategy: {
    purpose: "How you sell and who closes.",
    bullets: ["High-volume, ABM, or public-sector", "Name the closer (AE or founder)", "Match it to the offer"],
    example: "High-volume outbound; founder closes.",
  },
  icp: {
    purpose: "Who to target - the generated brief follows this.",
    bullets: ["Industry, titles, seniority, company size, geography", "A trigger: hiring, funding, or tool stack", "Mark private or public sector"],
    example: "US professional services, 20-80 people, COO/Ops/Managing Partner, on M365, no in-house SDR.",
  },
  lead_import: {
    purpose: "This list is people who match your ICP and can be emailed at work.",
    bullets: ["Work emails only - no home addresses", "CSV columns: name, title, company, work email, LinkedIn URL", "Apollo sandbox contacts cannot live-send"],
    example: "Dana Alvarez, VP RevOps, Meridian Analytics, dana@meridian.com, linkedin.com/in/dana",
  },
  lead_email: {
    purpose: "Use a work email so sends are compliant and deliverable.",
    bullets: ["Business domain, not personal", "No home addresses or personal inboxes", "One verified address per contact"],
    example: "dana@meridian.com",
  },
  campaign_name: {
    purpose: "Name it by motion plus quarter - not a slogan.",
    bullets: ["Format like 'Outbound Q3' or 'ABM Q3'", "Keeps reporting readable", "Skip clever or branded names"],
    example: "RevOps Outbound Q3",
  },
  campaign_offer: {
    purpose: "Pick the offer this campaign sells.",
    bullets: ["The sequence is written from the offer", "No offer? Create one first", "Type and strategy should match it"],
    example: "DealsOps Professional",
  },
  campaign_typestrat: {
    purpose: "Match the offer's sector and motion.",
    bullets: ["Private or public sector", "High-volume, ABM, or procurement", "Stay consistent with the offer"],
    example: "Private sector - high-volume outbound",
  },
  seq_steps: {
    purpose: "Write steps that earn a reply, not just bumps.",
    bullets: ["Step 1: short first-touch, one ask", "Later steps: a new angle, not 'just bumping'", "One CTA per email - reply or book"],
    example: "Day 1: 'Worth a 15-min look?' Day 4: new angle on cost per meeting.",
  },
  seq_personalize: {
    purpose: "Personalize from real fields only.",
    bullets: ["Use name, title, company you actually have", "If research is missing, stay at role and company", "Never invent facts"],
    example: "Hi Dana - most VP RevOps at 50-person firms...",
  },
  campaign_public: {
    purpose: "Name the agency type and role you're targeting - not 'government people'.",
    bullets: ["Say the agency type and the buyer's role", "An offer with a generated ICP is required", "Factual copy only - no invented awards or contracts"],
    example: "State DOT procurement officers and contracting specialists.",
  },
  seq_public: {
    purpose: "Public-sector steps: one clear ask, published work email only.",
    bullets: ["One ask per email - no invented awards or 'we will win' claims", "Published work email only - never home mail", "No political or partisan targeting"],
    example: "Day 1: 'Are you the right contact for professional-services acquisitions?'",
  },
};
